import classNames from 'classnames'
import s from './index.module.css'
import { PlusIconFatty } from '@/utils/icons'

export const ButtonAdd = (props) => <button {...props} className={s.btnAdd}><PlusIconFatty /></button>

export const ButtonRemove = (props) => <button {...props} className={classNames(s.btnRemove, {[props.className]: props.className})}><PlusIconFatty /></button>